import Type from './Type';
export function isIDiscourseStatement(discourse) {
    return discourse.type === Type.Statement;
}
export {
    isIDiscourseStatement as isIStatement
};
export default isIDiscourseStatement;    //# sourceMappingURL=isIStatement.js.map
